export const secrets = {
  api: {
    clientSecret: "Ae9tl11ru8",
  },
  tap: {
    public_key: "pk_test_fdPZh5V9sAtrUWcbLwECvIXB",
  },
  firbase: {
    apiKey: "AIzaSyBifyUwkJdeJCK55Y7pyzglNp1pS68oU3c",
    vapidKey:
      "BK2qt31bViId2ZiEutnFZB9tgqA3T_D6X3BavK41p7KtcjOz14GZw96ib5a7E5Z4Sfd4O2hGQAeTeQxdARbStTs",
  },

  segmentAnalytics: {
    key: "xlqOJDSyYsCO3Yu70k3g1Pcj8HOt559d",
  },
  amplitudeAnalytics: {
    key: "7346b8357c463faebea5f0346ff1717e",
  },
  kekaCareers: {
    key: "a19960b8-1dc8-4788-9544-3335b26ea14a",
  },

  sentry: {
    dns: "https://d868c1e8c2fe57111665fadfa81c11d9@o4509994041868288.ingest.us.sentry.io/4510000390012929",
  },
  hcaptcha: {
    siteKey: "b7a91006-f3d5-4cc1-947e-7b69136d1847",
    passiveSiteKey: "771618c2-3d72-4104-b614-ec3289887396",
  },
};